module.exports = __webpack_public_path__ + "img/pasture_panicum_high.c8ad02be.jpg";